
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Header",
  components: {},
  props: {},
  setup() {
    const router = useRouter();
    const toTop = () => router.push({ name: "top" });

    function onClickHomeIcon() {
      if (confirm("編集を破棄してホーム画面に戻りますか？")) {
        toTop();
        return;
      } else {
        return;
      }
    }

    return {
      onClickHomeIcon,
    };
  },
});
